import * as comparableListings from 'actionCreators/comparableListings';
import * as comparableSales from 'actionCreators/comparableSales';
import * as comparableRentals from 'actionCreators/comparableRentals';

export const COMPARABLE_TYPE = {
  LISTINGS: 'listings',
  SALES: 'sales',
  RENTALS: 'rentals',
};

export const comparableActions = {
  [COMPARABLE_TYPE.LISTINGS]: {actions: comparableListings, name: 'comparableListings'},
  [COMPARABLE_TYPE.SALES]: {actions: comparableSales, name: 'comparableSales'},
  [COMPARABLE_TYPE.RENTALS]: {actions: comparableRentals, name: 'comparableRentals'},
};